import { BasePalette, Palette } from '../general/color-palette';
import { Theme } from '../general/theme';
import { TextDirection } from '../general/text-direction';

const grey: BasePalette = {
  100: '#000000', // Black
  150: '#05070B', // New black in figma
  200: '#1A1B1B', // Dark Grey
  250: '#1D1717', // Nero
  300: '#303131', // Swamp
  350: '#646464', // Dim Gray
  375: '#767676', // Grey
  380: '#ADADAD', // Light Grey
  400: '#B5B6B6', // Light Grey
  425: '#928A86', // Warm Suva Grey
  450: '#989392', // Suva Grey
  475: '#A99F99', // Del Rio
  500: '#A3A4A4', // Hit Grey
  550: '#ABABAB', // Dark Grey
  560: '#767676', // Darker Grey
  655: '#C1BEBB', // Pale Slate
  750: '#BFBFBF', // Silver
  800: '#D1D1D1', // Brighter Grey
  850: '#DEDEDE', // Gainsboro
  860: '#E4E4E4', // Soft Grey
  875: '#F4F3F0', // Romance
  900: '#FFFFFF', // White
};

const brown: Palette = {
  150: '#1D1717', // Warm black
  250: '#2F2726', // Warm chocolate
  350: '#655A54', // Dark Chocolate
  450: '#9E8D79', // Pale Oyster
  500: '#9D8C83', // Dark Champagne
  550: '#A59483', // Zorba
  600: '#E4E1DA', // Timid Lime
  650: '#AD9D91', // Warm Del Rio
  700: '#C6B8AE', // Tide
  800: '#D2C7BE', // Gold Champagne
  850: '#E6E0DB', // Spring Wood
  900: '#E9E7E1', // Light Champagne
};

const red: Palette = {
  100: '#E0302D', // Light Red
  150: '#B21300', // Dark Red
  300: '#820030', // Carmin Deep
  350: '#D51121', // Fire Engine Red
  500: '#B51E41', // Cardinal ***
  600: '#AD0040', // Jazzberry Jam
  700: '#CA3D71', // Royal Heath
  750: '#DA6691', // Pale Violet Red
  800: '#ED96B6', // Illusion
  850: '#F8E7E9', // Amour
};

const alert: Palette = {
  100: '#0A8D9E', // Eastern Blue
  150: '#6C8798', // Blue
  175: '#B5C3CB', // Ice Blue
  180: '#F0F3F5', // Light Blue
  185: '#018A11', // Dark Green
  190: '#09AA59', // Light Green
  200: '#32AA78', // Medium Sea Green
  250: '#C75300', // Dark Orange
  300: '#E98E15', // Carrot Orange
  350: '#FF8F26', // Light Orange
  700: '#E6F3F5', // Light Cyan
  800: '#EAF6F1', // Clear Day
  900: '#FCF3E7', // Linen
};

export const dsTheme: Theme = {
  currentDirection: 'ltr',
  color: {
    base: grey,
    primary: brown,
    secondary: red,
    accent: alert,
  },
  font: {
    normal: 'DSAutomobiles, Arial',
    primary: 'DSAutomobilesCondensed, Arial',
    secondary: 'DSTitleWebMedium, Arial',
    tertiary: 'DSTitleWebSmall, Arial',
    accent: 'DSTitleWebBig, Arial',
  },
  fontSize: {
    smaller: 11,
    small: 14,
    normal: 16,
    big: 24,
    bigger: 26,
    large: 36,
    extraLarge: 48,
    huge: 52,
  },
  breakPoint: {
    mobile: 450,
    tablet: 960,
    smallDesktop: 1280,
  },
  get direction() {
    return this.currentDirection;
  },
  set direction(direction: TextDirection) {
    this.currentDirection = direction;
  },
};
